/* Session-only derived choices. Never persist a child's exact age or height. */
(() => {
  if (window.LilPilloShortlist) return;
  const key = 'lp-shortlist-v1';
  const sizes = ['mini', 'full', 'large'];
  const preferences = ['no-down', 'no-latex', 'soft', 'adaptive', 'silk', 'down', 'structure', 'easy-care'];
  let memory;
  const clean = value => {
    if (!value || value.version !== 1 || !Array.isArray(value.sizes) || !Array.isArray(value.preferences) || !Array.isArray(value.handles)) return null;
    if (!value.sizes.length || !value.sizes.every(x => sizes.includes(x)) || !value.preferences.every(x => preferences.includes(x)) || !value.handles.every(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x))) return null;
    return {version:1, sizes:[...new Set(value.sizes)], preferences:[...new Set(value.preferences)], handles:[...new Set(value.handles)].slice(0, 3)};
  };
  const get = () => { try { return clean(JSON.parse(sessionStorage.getItem(key))) || memory || null; } catch (_) { return memory || null; } };
  const save = value => { memory = clean({...value, version:1}); try { if (memory) sessionStorage.setItem(key, JSON.stringify(memory)); } catch (_) {} return memory; };
  const clear = () => { memory = null; try { sessionStorage.removeItem(key); } catch (_) {} };
  const matches = (tokens, chosen = get()?.preferences || []) => {
    const actual = String(tokens || '').split(/\s+/);
    const exclusions = chosen.filter(x => ['no-down', 'no-latex'].includes(x));
    const styles = chosen.filter(x => !['no-down', 'no-latex'].includes(x));
    return exclusions.every(x => actual.includes(x)) && (!styles.length || styles.some(x => actual.includes(x)));
  };
  window.LilPilloShortlist = {get, save, clear, matches};
})();
